exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-0edb1b21] {\r\n  height: 24px;\r\n  fill: #333;\r\n  margin-top: 0.3rem;\n}\n.profile-photo[data-v-0edb1b21] {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  margin: -.375rem 0;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0edb1b21","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Navbar.vue
// module id = QhGl
// module chunks = 70